/*
    Renders the folder/media tag maintenance cleanup modal which allows the removal of duplicate and non-existent assets.
*/
import Locale from '../util/Locale';

export default function renderMaintenanceCleanupModal(maintenance, setShowModal, doMaintenanceCleanup) {
    if (!setShowModal || !doMaintenanceCleanup) {
        return;
    }
    let content = null;
    if (maintenance.status === 'collecting') {
        content = <p>Finding duplicate and non-existent assets...</p>;
    } else if (maintenance.status === 'ready') {
        if (maintenance.assets.length === 0) {
            content = <p>No duplicate or non-existent assets found for cleanup.</p>;
        } else {
            content = <p>{`${maintenance.assets.length} assets marked for cleanup.`}</p>;
        }
    } else if (maintenance.status === 'deleting') {
        content = <p>Deleting selected assets...</p>;
    } else if (maintenance.status === 'completed') {
        content = <p>Cleanup completed with {maintenance.failures.length} failures.</p>;
    }
    setShowModal({
        title: 'Cleanup duplicate/non-existent assets',
        className: 'maintenance-modal',
        content: (
            <>
                <div className="content">{content}</div>
                <div className="add-footer">
                    <nsemble-button
                        key="YES"
                        destructive-text
                        onClick={() => doMaintenanceCleanup(maintenance.assets)}
                        disabled={maintenance.status !== 'ready' || maintenance.assets.length === 0 ? true : undefined}
                    >
                        {Locale.getText('DELETE_FILES')}
                    </nsemble-button>
                    <nsemble-button key="CLOSE" text onClick={() => setShowModal(false)}>
                        {Locale.getText('CLOSE')}
                    </nsemble-button>
                </div>
            </>
        )
    });
}
